export default "__VITE_ASSET__B74Q5C37__"